import { NgModule } from '@angular/core';
import { SafePipe } from '../../../@core/pipes/safe.pipe';
import { SafeHtmlPipe } from '../safe-html.pipe';
import { SafeUrlPipe } from '../safe-url.pipe';

@NgModule({
    imports: [],
    declarations: [SafePipe,SafeHtmlPipe,SafeUrlPipe],
    exports: [SafePipe,SafeHtmlPipe,SafeUrlPipe],
 })

 export class SafeModule {

   static forRoot() {
      return {
        ngModule: SafeModule,
        providers: [SafePipe,SafeHtmlPipe,SafeUrlPipe],
      };
   }
}
